import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
import history from 'utils/history';
import { LOAD_SETTINGS } from './constants';

import {
  loadSettingsError,
  loadSettingsSuccess,
} from './actions';

// utils
import _local from 'utils/localStorageUtils';
import api from 'utils/api';
const { endpoint } = api;

export function* loadSettings() {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();

    // we get the campaigns linked to the settings
    const settingsList = yield requestWrapper(
      'GET',
      endpoint?.students?.list,
      '',
      currentUser?.token
    );

    if (!settingsList) {
      yield put(loadSettingsSuccess(false));
    } else {
      yield put(loadSettingsSuccess(settingsList));
    }
  } catch (error) {
    yield put(loadSettingsError(error));
  }
}

export default function* settingsSaga() {
  yield takeLatest(LOAD_SETTINGS, loadSettings);
}
